import { DataHandlerScene, Scene } from "luxedo-data"
import { LuxedoRPC, type JobStatus } from "luxedo-rpc"
import { ProgressContext } from "./ProgressContext.svelte"

class PreviewProcessProgressCtx extends ProgressContext<Scene> {
	/** Every scene job (render, direct-upload processing, preview) ends by writing render_ver. */
	protected completionMarker(id: number): string | null {
		const scene = DataHandlerScene.get(id)
		if (!scene) return null
		return String(scene.render_ver?.getTime() ?? "none")
	}

	protected describe(id: number): string {
		return `scene ${id}`
	}

	protected async fetchStatuses(ids: Array<number>): Promise<{ [id: string]: JobStatus }> {
		return (await LuxedoRPC.api.scene.project_processing_status(ids, "project_preview")).status
	}

	async processPreview(sceneId: number) {
		await LuxedoRPC.api.scene.project_process_preview(sceneId)
	}

	protected async getCompletedData(id: number): Promise<Scene> {
		await DataHandlerScene.pull([id])
		return DataHandlerScene.get(id)
	}
}

export const PreviewProcessingProgressContext = new PreviewProcessProgressCtx({
	progress: "proj_preview_process_prog",
	complete: "proj_preview_process_complete",
	fail: "proj_preview_process_fail",
})
